import styled from 'styled-components'

export const AuditBadges = styled.div`
  display: flex;
  align-items: center;
  padding: 0 var(--tds-spacing-element-16);

  & > * {
    margin: 0 0 0 8px;
  }

  &:first-child {
    margin: 0;
  }
`
